// Oral photos, X-rays and 3D models (v1, cursor-paginated).
import api, {withIdempotencyKey} from './client';

/** Fetches every page of the cursor-paginated listing for the given range. */
export const getAllOralPhotos = async (photoType, dateRange) => {
  const q = new URLSearchParams({limit: '100'});
  if (photoType && photoType !== 'all') q.set('photo_type', photoType);
  if (dateRange && dateRange[0]) q.set('start_date', dateRange[0]);
  if (dateRange && dateRange[1]) q.set('end_date', dateRange[1]);
  const all = [];
  let cursor = null;
  for (let page = 0; page < 50; page += 1) {
    if (cursor) q.set('cursor', cursor);
    const r = await api.get(`/me/oral-photos?${q}`);
    all.push(...r.data.items);
    cursor = r.data.next_cursor;
    if (!cursor) break;
  }
  return all;
};

export const getOralPhotoById = (id) => api.get(`/me/oral-photos/${id}`).then((r) => r.data);

export const createOralPhoto = (d, opts = {}) =>
  api
    .post(
      '/me/oral-photos',
      {
        shoot_date: d.shoot_date,
        photo_type: d.photo_type,
        note: d.note || '',
        file_name: d.file_name || undefined,
        image: d.image_link || d.image,
      },
      withIdempotencyKey(opts.idempotencyKey),
    )
    .then((r) => r.data);

export const updateOralPhoto = (id, d) =>
  api.patch(`/me/oral-photos/${id}`, {
    ...(d.shoot_date !== undefined && {shoot_date: d.shoot_date}),
    ...(d.photo_type !== undefined && {photo_type: d.photo_type}),
    ...(d.note !== undefined && {note: d.note}),
  });

export const deleteOralPhoto = (id) => api.delete(`/me/oral-photos/${id}`);
